//The contents of this file have been generated automatically. Do not edit this file.

import * as t from 'io-ts';
import { isRight } from 'fp-ts/lib/Either';
import { fetchGeneralRaw, FetchGeneralRawResponseType } from 'src_common/common/fetch';
import { ApiTimeLog } from 'src_common/server/webDriver/logFormat';


export interface ParamsType {
    customer_id: number;
    requestBody: {
        from: string;
        to: string;
    };
}


const createGuard = <A>(code: number, decoder: t.Type<A, A, unknown>): ((data: unknown) => A) => {
    return (data: unknown): A => {
        const decodeResult = decoder.decode(data);
        if (isRight(decodeResult)) {
            return decodeResult.right;
        }
        throw Error(`Response decoding error /api-proxy/staff/affordability/check-audit/{customer_id} -> post -> ${code}`);
    };
};

export const Response200IO = t.array(t.interface({
    accountId: t.number,
    affordabilityColor: t.string,
    checkDate: t.string,
    checkTrigger: t.string,
    reason: t.union([t.null, t.undefined, t.string]),
    reviewDate: t.union([t.null, t.undefined, t.string]),
    reviewed: t.union([t.null, t.undefined, t.boolean]),
    reviewerId: t.union([t.null, t.undefined, t.number]),
    reviewerName: t.union([t.null, t.undefined, t.string]),
    universe: t.string,
}));
export type Response200Type = Array<{
    accountId: number;
    affordabilityColor: string;
    checkDate: string;
    checkTrigger: string;
    reason?: null | undefined | string;
    reviewDate?: null | undefined | string;
    reviewed?: null | undefined | boolean;
    reviewerId?: null | undefined | number;
    reviewerName?: null | undefined | string;
    universe: string;
}>;
export const decodeResponse200 = createGuard(200, Response200IO);

export const Response400IO = t.string;
export type Response400Type = string;
export const decodeResponse400 = createGuard(400, Response400IO);

export const Response401IO = t.string;
export type Response401Type = string;
export const decodeResponse401 = createGuard(401, Response401IO);

export const Response500IO = t.string;
export type Response500Type = string;
export const decodeResponse500 = createGuard(500, Response500IO);



type ExtraHeadersType = Record<string, string>


/**
 * @deprecated - Please use this method "openapiProxyStaffAffordabilityCheckAuditRequest"
 */
export const openapi_proxy_staff_affordability_check_audit = async (api_url: string, api_timeout: number, backendToken: string, params: ParamsType, extraHeaders?: ExtraHeadersType): Promise<FetchGeneralRawResponseType> => {
    
        
    const query = '';
    const url = `${api_url}/api-proxy/staff/affordability/check-audit/${params.customer_id}${query}`;
    
    const method = 'POST';
    const paramsFetch = {
        url,
        body: params.requestBody,
        backendToken,
        timeout: api_timeout,
        extraHeaders,
    };

    const apiTime = ApiTimeLog.createWithProcessEnv(method, url);
    const response = await fetchGeneralRaw(method, paramsFetch);
    apiTime.show(response.status);
    return response;
};


export type OpenapiProxyStaffAffordabilityCheckAuditParamsType = ParamsType;

export type OpenapiProxyStaffAffordabilityCheckAuditResponseType = {
    status: 200;
    body: Response200Type;
} | {
    status: 400;
    body: Response400Type;
} | {
    status: 401;
    body: Response401Type;
} | {
    status: 500;
    body: Response500Type;
};

export type OpenapiProxyStaffAffordabilityCheckAuditResponse200Type = Response200Type;

export const openapiProxyStaffAffordabilityCheckAuditRequest = async (api_url: string, api_timeout: number, backendToken: string, params: ParamsType, extraHeaders?: ExtraHeadersType): Promise<OpenapiProxyStaffAffordabilityCheckAuditResponseType> => {
    const response = await openapi_proxy_staff_affordability_check_audit(api_url, api_timeout, backendToken, params, extraHeaders);
    const { status, body } = response;

    let json = null;

    try {
        json = JSON.parse(body);
    } catch (_err) {
        console.warn(`Http status ${status} - json was expected`);
        json = {};
    }
    
    if (status === 200) {
        return { status: 200, body: decodeResponse200(json) };
    }

    if (status === 400) {
        return { status: 400, body: decodeResponse400(json) };
    }

    if (status === 401) {
        return { status: 401, body: decodeResponse401(json) };
    }

    if (status === 500) {
        return { status: 500, body: decodeResponse500(json) };
    }

    throw new Error(`openapiProxyStaffAffordabilityCheckAuditRequest - unhandled response ${response.status}`);
};

